import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { XCircle, ArrowLeft, CreditCard, Home } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { metaPixel } from '@/utils/meta-pixel';

export const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();

  // Track payment abandonment
  React.useEffect(() => {
    metaPixel.trackPaymentAbandoned();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
      <Helmet>
        <title>Paiement annulé - DPEWizard</title>
        <meta name="description" content="Votre paiement a été annulé. Aucun montant n'a été débité de votre compte." />
      </Helmet>
      
      <Card className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center mb-6">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-12 h-12 text-red-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Paiement annulé
          </h1>
          <p className="text-gray-600">
            Votre paiement a été annulé. Aucun montant n'a été débité.
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg p-6 mb-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">
            Que souhaitez-vous faire ?
          </h2>
          
          <div className="space-y-2 text-sm text-gray-600">
            <p>• Retourner aux tarifs pour choisir une autre option</p>
            <p>• Contacter notre support si vous avez des questions</p>
            <p>• Revenir plus tard pour finaliser votre achat</p>
          </div>
        </div>

        <div className="space-y-3">
          <Button
            variant="primary"
            className="w-full"
            onClick={() => navigate('/pricing')}
          >
            <CreditCard className="w-5 h-5 mr-2" />
            Retourner aux tarifs
          </Button>
          
          <Button
            variant="outline"
            className="w-full"
            onClick={() => navigate('/dashboard')}
          >
            <Home className="w-5 h-5 mr-2" />
            Tableau de bord
          </Button>
          
          <Button
            variant="ghost"
            className="w-full"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Page précédente
          </Button>
        </div>

        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Besoin d'aide ?</strong> Notre équipe support est là pour vous aider. 
            Contactez-nous si vous rencontrez des difficultés.
          </p>
        </div>
      </Card>
    </div>
  );
};

export default PaymentCancelPage;